module.exports = __webpack_public_path__ + "static/whitegiraffehamper2-e4294d017e497d8c1fe7ad80b22c0e81.jpeg";